import { useState } from 'react'

import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import FormControl from '@mui/material/FormControl'
import { DatePicker } from '@mui/x-date-pickers/DatePicker'

import { SelectString } from '../../../../core/components/SelectString'
import { useSaveEvent } from '../../hooks/useSaveEvent'
import type { Project } from '../../types/Project'

const HERPLAN_REDENEN = [
  'Weersomstandigheden',
  'Gepland Conform Minimale Wachttijd',
  'Klant Verschuift Aansluitgereeddatum',
  'Klant Blijkt Niet Gereed',
  'Capaciteit Aannemer',
  'Voorbereiding Aannemer Niet Gereed',
  'Hoofdinfra Aanleggen',
  'Voorbereiding Netbeheerder Niet Gereed',
  'Bestaande Planning Bevestigd',
  'Niet Planbaar - Wacht Op Informatie Klant',
  'Niet Planbaar - Klant Niet Bereikbaar',
  'Niet Planbaar - Externe Omstandigheden',
]

interface Props {
  project: Project
  handleClose: () => void
}

export const Herplan = ({ project, handleClose }: Props) => {
  const { mutate: saveEvent } = useSaveEvent()
  const { aanvraagID, geplandeUitvoeringsdatum } = project

  const [date, setDate] = useState<Date | null>(
    geplandeUitvoeringsdatum ? new Date(geplandeUitvoeringsdatum) : null,
  )
  const [reden, setReden] = useState('')
  const [errors, setErrors] = useState({})
  const redenen = [...HERPLAN_REDENEN]

  const validate = () => {
    const dateError = !date
    const redenError = !reden

    setErrors({
      redenError,
      dateError,
    })

    return !(dateError || redenError)
  }

  const handleSubmitClick = () => {
    if (validate()) {
      saveEvent(
        // @ts-expect-error-next-line checked in validate()
        {
          id: aanvraagID,
          data: {
            geplandeUitvoeringsdatum: date,
            reden,
          },
          type: 'herplanning_klant',
          source: 'manual',
        },
        {
          onSuccess: () => handleClose(),
        },
      )
    }
  }

  return (
    <>
      <DialogTitle>Herplannen project {aanvraagID}</DialogTitle>
      <DialogContent>
        <Box sx={{ mb: 2 }}>
          <DatePicker
            disablePast
            label="Geplande uitvoeringsdatum"
            value={date}
            onChange={(date) => setDate(date || null)}
            displayWeekNumber
            slotProps={{
              field: { clearable: true },
              textField: {
                error: Boolean(errors['dateError']),
                variant: 'standard',
                sx: { width: '33%', pr: 1 },
              },
            }}
          />
        </Box>
        <FormControl variant="standard" sx={{ width: '100%' }}>
          <SelectString
            label="Reden"
            disableClearable
            value={reden}
            onChange={(reden) => setReden(reden)}
            error={errors['redenError']}
            options={redenen}
          />
        </FormControl>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="primary" autoFocus>
          Annuleren
        </Button>
        <Button color="primary" onClick={handleSubmitClick}>
          Opslaan
        </Button>
      </DialogActions>
    </>
  )
}
